<div class="settings-grid__container">
  <ag-grid-angular id="grid" #grid class="ag-theme-alpine ag-grid-sticky-header" [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [enableCellTextSelection]="true" [ensureDomOrder]="true"
    (gridReady)="onGridReady($event)" (rowDataUpdated)="onSettingsUpdated($event)" [rowData]="displayedSettings">
  </ag-grid-angular>
</div>